// REACT_APP_API_URL=http://localhost:8080 npm start points the app at a local API
export const API_URL = process.env.REACT_APP_API_URL || "https://api.puttr.co";
